import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useRole } from 'hooks/useRole';
import { useAuth } from 'hooks/useAuth';
import {
  getSubCounties,
  getRegions,
  getWards,
  getCounties,
} from 'store/location/actions';
import { getMe } from 'store/auth/login/actions';

const Authmiddleware = (props) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();
  const {
    isFacilitator,
    isSiteCord,
    isCountyCoordinator,
    isClusterLeader,
    isFinance,
    isRegionalCountyCoordinator,
    isDirector,
    isAdmin,
    isSuperAdmin,
    isData,
    addresses,
  } = useRole();
  // console.log('addresses in authmiddleware', addresses);
  // console.log('isAuthenticated in authmiddleware', isAuthenticated);
  const { wardId, constituencyId, countyId, regionId } = (isAuthenticated && addresses)
    ? addresses[0]
    : {};

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getMe());
      if (addresses) {
        dispatch(
          getRegions({
            ids: [],
            filter: isRegionalCountyCoordinator || isCountyCoordinator || isClusterLeader || isSiteCord || isFacilitator,
            addresses,
          }),
        );
        dispatch(
          getCounties({
            ids: [...new Set(addresses.map((a) => a.regionId))],
            filter: isCountyCoordinator || isClusterLeader || isSiteCord || isFacilitator,
            addresses,
          }),
        );
        dispatch(
          getSubCounties({
            ids: [...new Set(addresses.map((a) => a.countyId))],
            filter: isSiteCord,
            addresses,
          }),
        );
        dispatch(
          getWards({
            ids: [...new Set(addresses.map((a) => a.constituencyId))],
            filter: isFacilitator,
            addresses,
          }),
        );
      }
    }
  }, [isAuthenticated]);

  if (!localStorage.getItem('sessionToken')) {
    return (
      <Navigate to={{ pathname: '/login', state: { from: props.location } }} />
    );
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

Authmiddleware.propTypes = {
  location: PropTypes.any,
  children: PropTypes.any,
};

export default Authmiddleware;
